import type { HolidayguruWidget } from './HolidayguruWidget'
import type { WidgetDefinition } from '../global'

async function createWidget() {
  if (!import.meta.env.WIDGET_DEFINITION) {
    throw new Error('import.meta.env.WIDGET_DEFINITION not set')
  }
  const definition = import.meta.env
    .WIDGET_DEFINITION as unknown as WidgetDefinition
  const WidgetBase =
    'HolidayguruWidget' in window && window.HolidayguruWidget !== undefined
      ? (window.HolidayguruWidget as typeof HolidayguruWidget)
      : (await import('./HolidayguruWidget')).HolidayguruWidget
  const Widget = class extends WidgetBase {
    definition = definition
  }
  window.customElements.define(definition.tagName, Widget)
}

createWidget()
